// import * as d3 from "https://cdn.jsdelivr.net/npm/d3@7/+esm";

jQuery(document).ready(function () {
    // let data = '[{"name":"<5","value":19912018},{"name":"5-9","value":20501982},{"name":"10-14","value":20679786},{"name":"15-19","value":21354481},{"name":"20-24","value":22604232},{"name":"25-29","value":21698010},{"name":"30-34","value":21183639},{"name":"35-39","value":19855782},{"name":"40-44","value":20796128},{"name":"45-49","value":21370368},{"name":"50-54","value":22525490},{"name":"55-59","value":21001947},{"name":"60-64","value":18415681},{"name":"65-69","value":14547446},{"name":"70-74","value":10587721},{"name":"75-79","value":7730129},{"name":"80-84","value":5811429},{"name":"≥85","value":5938752}]'
    // console.log(singleJSON);
    // let data = JSON.parse(singleJSON);
    // console.log("lenght: " + data.length);

    // let pallete = createShadePallete(data.length, 0);
    let redPalette = [
        "#A80000",
        "#AD0C0C",
        "#B11818",
        "#B62424",
        "#BA3030",
        "#BF3D3D",
        "#C34949",
        "#C85555",
        "#CD6161",
        "#D16D6D",
        "#D67979",
        "#DA8585",
        "#DF9191",
        "#E49D9D",
        "#E8A9A9",
        "#EDB6B6",
        "#F1C2C2",
        "#F6CECE",
        "#FADADA",
        "#FFE6E6",
    ];

    let bluePalette = [
        "#003366",
        "#0C3D6E",
        "#184776",
        "#24517E",
        "#305B86",
        "#3D658E",
        "#496F96",
        "#55799E",
        "#6183A6",
        "#6D8DAE",
        "#7998B7",
        "#85A2BF",
        "#91ACC7",
        "#9DB6CF",
        "#A9C0D7",
        "#B6CADF",
        "#C2D4E7",
        "#CEDEEF",
        "#DAE8F7",
        "#E6F2FF",
    ]

    let greenPalette = [
        "#006600",
        "#0C6E0C",
        "#187618",
        "#247E24",
        "#308630",
        "#3D8E3D",
        "#499649",
        "#559E55",
        "#61A661",
        "#6DAE6D",
        "#79B779",
        "#85BF85",
        "#91C791",
        "#9DCF9D",
        "#A9D7A9",
        "#B6DFB6",
        "#C2E7C2",
        "#CEEFCE",
        "#DAF7DA",
        "#E6FFE6"
    ];

    let redTESTPalette = [
        "#e44f49",
        "#752e21",
        "#841220",
        "#e13639",
        "#470000",
        "#f86f77",
        "#fb7c60",
        "#983320",
        "#861824",
        "#7e2627",
        "#fa2932",
        "#f41151",
        "#b33333",
        "#fe3249",
        "#c0393e",
        "#813326",
        "#d61104",
        "#9b2c11",
        "#f07362",
        "#a92b1d",
    ];
    // [fixed, still needs fixed]
    // let fixedPalette = ["#39679C", "#adc0d6"];

    let fixedRedPalette = ["#A80000", "#EDB6B6"];
    let fixedBluePalette = ["#003366", "#B6CADF"];
    let fixedGreenPalette = ["#006600", "#B6DFB6"];

    if (typeof singleJSON !== 'undefined') {
        generateDonutGraph(singleJSON, redPalette, 'a-errors', 'a-error-text', 'a-errors');
    }
    if (typeof doubleJSON !== 'undefined') {
        generateDonutGraph(doubleJSON, bluePalette, 'aa-errors', 'aa-error-text', 'aa-errors');
    }
    if (typeof tripleJSON !== 'undefined') {
        generateDonutGraph(tripleJSON, greenPalette, 'aaa-errors', 'aaa-error-text', 'aaa-errors');
    }
    if (typeof singleFixedJSON !== 'undefined') {
        generateDonutGraph(singleFixedJSON, fixedRedPalette, 'a-errors', 'a-error-text', 'a-errors');
    }
    if (typeof doubleFixedJSON !== 'undefined') {
        generateDonutGraph(doubleFixedJSON, fixedBluePalette, 'aa-errors', 'aa-error-text', 'aa-errors');
    }
    if (typeof tripleFixedJSON !== 'undefined') {
        generateDonutGraph(tripleFixedJSON, fixedGreenPalette, 'aaa-errors', 'aaa-error-text', 'aaa-errors');
    }
    

    let fixedInstance = document.querySelectorAll('.completion-donut')
    for (let i = 0; i < fixedInstance.length; i++) {
        let elem = fixedInstance[i];
        let json = elem.dataset.donut;
        let codeId = elem.dataset.codeId;
        generateDonutGraph(json, fixedBluePalette, elem.parentNode.id, elem.id, codeId)
    }
});

function generateDonutGraph(data, palette, parentID, childID, codeID = null) {
    let existingSVG = document.getElementById(`svg-${codeID}`)
    if (typeof(existingSVG) !== 'undefined' && existingSVG!== null) {
        console.log('hit remove if statement')
        d3.select(`#svg-${codeID}`).remove()        
    }

    data = JSON.parse(data);
    const width = 200;

    const height = Math.min(width, 200);
    const radius = Math.min(width, height) / 2;

    const arc = d3
        .arc()
        .innerRadius(radius * 0.67)
        .outerRadius(radius - 1);

    const pie = d3
        .pie()
        .padAngle(1 / radius)
        .sort(null)
        .value((d) => d.value);
        
    const color = d3.scaleOrdinal().range(palette);

    const svg = d3
        .create("svg")
        .attr("width", width)
        .attr("height", height)
        .attr("viewBox", [-width / 2, -height / 2, width, height])
        .attr("style", "max-width: 100%; height: auto;");

    if (codeID) {
        svg.attr("id", `svg-${codeID}`);
    }

    svg.append("g")
        .selectAll()
        .data(pie(data))
        .join("path")
        .attr("fill", (d, i) => color(i))
        .attr("d", arc)
        .append("title")
        .text((d) => `${d.data.name}: ${d.data.value.toLocaleString()}`);

    svg.append("g")
        .attr("font-family", "sans-serif")
        .attr("font-size", 12)
        .attr("text-anchor", "middle")
        .selectAll()
        .data(pie(data))
        .join("text")
        .attr("transform", (d) => `translate(${arc.centroid(d)})`);


         let elem = document.getElementById(childID);

    // return svg.node();
    let container = document.getElementById(parentID);
    container.insertBefore(svg.node(), elem);
    // container.append(svg.node());
    // container.style.backgroundImage = url( "data:" + svg );
    // var encoded = window.btoa(svg);
    // container.style.background = "url(data:image/svg+xml;base64,"+encoded+")";
    // let svgString = new XMLSerializer().serializeToString(svg.node());

        // Encode the SVG string to base64
        // let encoded = window.btoa(unescape(encodeURIComponent(svgString)));

        // Set the background of the container div
        // container.style.background = `url(data:image/svg+xml;base64,${encoded})`;
}

// function createShadePallete(numOfShades, hue) {
//     let shades = [];

//     function rand(min, max) {
//         return Math.floor(Math.random() * (max - min + 1)) + min;
//     }

//     for (var i = 0; i < numOfShades; i++) {
//         // Create shades!
//         var hsl =
//             "hsl(" + hue + ", " + rand(10, 90) + "%, " + rand(10, 90) + "%)";
//         let hex = hslToHex(hue, rand(10, 90), rand(10, 90));
//         shades.push(hex);
//     }
//     console.log(shades);
//     return shades;
// }

// function hslToHex(h, s, l) {
//     l /= 100;
//     const a = (s * Math.min(l, 1 - l)) / 100;
//     const f = (n) => {
//         const k = (n + h / 30) % 12;
//         const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
//         return Math.round(255 * color)
//             .toString(16)
//             .padStart(2, "0"); // convert to Hex and prefix "0" if needed
//     };
//     return `#${f(0)}${f(8)}${f(4)}`;
// }
